import React from "react";

function TrendDown() {
  return (
    <>
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0628 8.00026V11.7503C14.0628 11.8746 14.0134 11.9938 13.9255 12.0817C13.8376 12.1696 13.7183 12.219 13.594 12.219H9.84401C9.75125 12.2191 9.66055 12.1916 9.58339 12.1401C9.50624 12.0886 9.4461 12.0154 9.41059 11.9297C9.37509 11.844 9.3658 11.7497 9.38392 11.6587C9.40204 11.5677 9.44674 11.4842 9.51237 11.4186L11.0563 9.87526L7.96901 6.78796L5.9569 8.80065C5.91337 8.84423 5.86167 8.87881 5.80476 8.9024C5.74786 8.92599 5.68686 8.93813 5.62526 8.93813C5.56366 8.93813 5.50266 8.92599 5.44576 8.9024C5.38885 8.87881 5.33715 8.84423 5.29362 8.80065L1.07487 4.5819C0.986913 4.49394 0.9375 4.37465 0.9375 4.25026C0.9375 4.12587 0.986913 4.00658 1.07487 3.91862C1.16283 3.83066 1.28212 3.78125 1.40651 3.78125C1.5309 3.78125 1.65019 3.83066 1.73815 3.91862L5.62526 7.80632L7.63737 5.79362C7.6809 5.75004 7.7326 5.71546 7.78951 5.69187C7.84641 5.66828 7.90741 5.65614 7.96901 5.65614C8.03061 5.65614 8.09161 5.66828 8.14851 5.69187C8.20542 5.71546 8.25712 5.75004 8.30065 5.79362L11.719 9.21257L13.2624 7.66862C13.3279 7.60299 13.4115 7.55829 13.5025 7.54017C13.5934 7.52205 13.6877 7.53133 13.7734 7.56684C13.8591 7.60235 13.9324 7.66249 13.9839 7.73964C14.0354 7.8168 14.0628 7.9075 14.0628 8.00026Z"
          fill="#B21717"
        />
      </svg>
    </>
  );
}

export default TrendDown;
